// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"c525b00b","855":"f88ed466","950":"7d1b7c22"}[chunkId] + ".chunk.css";
};